<div class="ui modal"
     id="Livetracker_Modal">
  <div class="standings-modal-row">
    <div class="button-row">
      <button class="ui icon button" (click)="OpenLiveTrackerOnSecondScreen()">
        <i class="white external alternate double up large icon"></i>
      </button>

      <button class="ui icon button" (click)="modalHide()">
        <i class="white close large icon"></i>
      </button>

    </div>

  </div>

  <div *ngIf="!this.enableBetGeniusTracker" id="LivetrackerContainer">
    <div class="sr-widget sr-widget-1" id="Livetracker"></div>
  </div>

  <div *ngIf="this.enableBetGeniusTracker">
    <iframe scrolling="no" id="betgenius-iframe" [src]="this.betgeniustrackerlink" width="50%" height="289"></iframe>
  </div>

</div>
